const getDrakryggenLogoPicture = function () {
  return `/images/dr_logo.png`;
};

export default getDrakryggenLogoPicture;
